import { render } from "./mutitabs.vue?vue&type=template&id=5c1b99f1"
import script from "./mutitabs.vue?vue&type=script&lang=js"
export * from "./mutitabs.vue?vue&type=script&lang=js"

import "./mutitabs.vue?vue&type=style&index=0&id=5c1b99f1&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__